//# sourceMappingURL=function.mjs.map
/**
 * Takes a single argument and always returns its input value.
 */
export function identity(x) {
  return x;
}
